export type SignatureBlockReason = 'contact' | 'customerName';

export function getSignatureBlockReason(
  isContactVerified: boolean,
  hasCustomerName: boolean,
): SignatureBlockReason | null {
  if (!isContactVerified) {
    return 'contact';
  }
  if (!hasCustomerName) {
    return 'customerName';
  }
  return null;
}
